"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _videoPlay = _interopRequireDefault(require("@atlaskit/icon/core/video-play"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidPlayIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
}, props, {
  newIcon: _videoPlay.default
}));
VidPlayIcon.displayName = 'VidPlayIcon';
var _default = exports.default = VidPlayIcon;